export const BRAND = {
  name: 'Mini Constructores',
  tagline: 'Robótica para niños',
  productMockup: 'https://cdn.magicpatterns.com/uploads/aa92THaJx5ZtDGydNZezuv/pasted-image.png',
  price: '$17.990',
  currency: 'ARS',
  compareAtPrice: '$36.990',
  installments: '3 cuotas sin interés de $5.996',
  ctaLabel: 'QUIERO ACCEDER AHORA',
  ctaLabelAlt: 'QUIERO EL ACCESO COMPLETO',
  checkoutUrl: 'https://checkout.miniconstructores.shop/cart/47432004960340:1'
}

export const HERO = {
  badge: '🤖 ROBÓTICA CREATIVA PARA NIÑOS',
  headline: 'CHAUCELULAR',
  subtitle: 'En menos de 10 minutos, tu hijo puede estar creando su primer robot en casa.',
  description:
    'Transformá esas horas frente a una pantalla en tiempo de creatividad, aprendizaje y diversión.',
  features: ['▶ Videos paso a paso', '∞ Acceso para siempre'],
}

export const MATERIALS = {
  title: '¡SIN GASTAR DE MÁS!',
  emoji: '🏠',
  headline: 'EMPEZÁ HOY MISMO',
  subtitle: 'Solo necesitás materiales que ya tenés en casa',
  description:
    'Cajas, cartón, botellas, tapitas y tubos se transforman en increíbles proyectos de robótica.',
  items: [
    { emoji: '📦', text: 'Cajas' },
    { emoji: '🧴', text: 'Botellas' },
    { emoji: '🧻', text: 'Tubos' },
    { emoji: '🔵', text: 'Tapitas' },
  ],
}

export const QUICK_BENEFITS = [
  { emoji: '🎥', title: 'Videos fáciles', description: 'Explicados paso a paso' },
  { emoji: '🧩', title: 'Proyectos creativos', description: 'Para aprender jugando' },
  { emoji: '📥', title: 'Material descargable', description: 'Listo para usar' },
  { emoji: '🎁', title: 'Bonos incluidos', description: 'Sin costo adicional' },
]

export const SCREEN_TIME = {
  title: 'MENOS PANTALLA,',
  titleHighlight: 'MÁS CREACIÓN',
  description:
    'Con Mini Constructores, la pantalla deja de ser tiempo vacío y se convierte en una guía para crear.',
  benefits: [
    { emoji: '💡', text: 'Estimula la creatividad' },
    { emoji: '🧩', text: 'Aprende jugando' },
    { emoji: '🏠', text: 'Usa materiales de casa' },
    { emoji: '📵', text: 'Menos pantalla vacía' },
  ],
}

export const FOR_YOUR_CHILD = {
  title: '💙 PENSADO PARA TU HIJO',
  subtitle: 'Esto es para vos',
  description: 'si querés que tu hijo...',
  tagline: 'Menos pantalla, más creatividad y aprendizaje.',
  items: [
    { emoji: '📱', title: 'Menos celular', description: 'Una actividad que sí lo entretenga.' },
    { emoji: '🎨', title: 'Más creatividad', description: 'Que imagine, invente y cree.' },
    { emoji: '🧠', title: 'Mente activa', description: 'Aprender mientras juega.' },
    { emoji: '🤖', title: 'Manos a la obra', description: 'Crear con materiales simples.' },
    {
      emoji: '🚀',
      title: 'Se anime a probar',
      description: 'Probar, equivocarse y volver a intentar.',
    },
    {
      emoji: '🏆',
      title: 'Se sienta orgulloso',
      description: 'Sentirse feliz por lo que creó.',
    },
  ],
}

export const HOW_IT_WORKS = {
  badge: '🤖 ASÍ FUNCIONA MINI CONSTRUCTORES',
  title: 'Con Mini Constructores, crear es fácil.',
  description:
    'Tu hijo mira, sigue el paso a paso y empieza a crear con sus manos.',
  steps: [
    { number: '1', title: 'Abrís un video', description: 'Elige un proyecto y ve qué hacer.' },
    {
      number: '2',
      title: 'Sigue el paso a paso',
      description: 'Usa materiales simples que ya tenés en casa.',
    },
    {
      number: '3',
      title: 'Armá, creá y jugá',
      description: 'Construye, prueba y disfruta lo que hizo.',
    },
  ],
  result: {
    title: '✓ RESULTADO',
    description: 'Menos pantalla. Más creación.',
    subtitle: 'Una actividad lista para transformar el aburrimiento en creatividad.',
  },
}

export const WHY_IT_WORKS = {
  badge: '💡 MINI CONSTRUCTORES',
  title: '¿Por qué funciona?',
  description:
    'Porque la pantalla deja de ser solo entretenimiento y se convierte en una guía para crear.',
  points: [
    { emoji: '📱', title: 'Pantalla con propósito', description: 'Mira un video y aprende qué hacer.' },
    { emoji: '🙌', title: 'Manos en acción', description: 'Construye, prueba y juega.' },
    { emoji: '🏠', title: 'Materiales de casa', description: 'Cajas, botellas, cartón y tapitas.' },
  ],
}

export const PROJECTS_SECTION = {
  badge: '🤖 PROYECTOS REALES',
  title: 'Mirá todo lo que',
  titleHighlight: 'tu hijo va a poder crear',
  description: 'Robots, inventos, juegos y experimentos explicados paso a paso.',
  tagline: 'Más que mirar una pantalla: ahora puede crear con sus manos.',
}

export type Project = {
  title: string
  tag: string
  image: string
  tint: 'sky' | 'grass' | 'orange' | 'navy'
}

export const PROJECTS: Project[] = [
  {
    title: 'Robot de cartón',
    tag: 'Robótica casera',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7be21872-d286-4a3f-930b-ef2ceef26b37.jpg',
    tint: 'orange',
  },
  {
    title: 'Auto con tapitas',
    tag: 'Mecánica',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/cf099056-50c0-4228-bee4-6f0cd45da06b.jpg',
    tint: 'sky',
  },
  {
    title: 'Catapulta',
    tag: 'Física divertida',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/11b6844f-2657-40b1-964e-e9f70e398ee6.jpg',
    tint: 'grass',
  },
  {
    title: 'Puente de papel',
    tag: 'Ingeniería',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d9b36229-bf4f-4278-a3d2-34970be42815.jpg',
    tint: 'navy',
  },
  {
    title: 'Animales de cartón',
    tag: 'Arte y reciclaje',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ee57c82e-d64d-4173-b2f3-308f81e8b08d.jpg',
    tint: 'grass',
  },
  {
    title: 'Cohete espacial',
    tag: 'Aventura',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/cc11e255-b335-42e3-9b8f-687f0b2d9fa0.jpg',
    tint: 'orange',
  },
  {
    title: 'Nave exploradora',
    tag: 'Imaginación',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7748c49f-4da6-4dc6-84cc-dbe62ff0a5a4.jpg',
    tint: 'sky',
  },
  {
    title: 'Grúa casera',
    tag: 'Mecanismos',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/77554fc1-d47a-4c55-b9b8-3c878292f40d.jpg',
    tint: 'navy',
  },
  {
    title: 'Instrumentos reciclados',
    tag: 'Música',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/249e3270-60f9-4bd8-a97f-f268c1a4b5a9.jpg',
    tint: 'orange',
  },
]

export const WHATS_INCLUDED = {
  badge: '🎁 TU ACCESO INCLUYE',
  title: 'Todo lo que',
  titleHighlight: 'recibís hoy',
  description: 'Con tu compra accedés de forma inmediata a todo esto:',
  items: [
    {
      label: 'INCLUIDO',
      emoji: '🤖',
      title: 'Mini Constructores: Robótica para niños',
      description:
        'Videos paso a paso para crear robots, inventos y proyectos simples desde casa.',
    },
    {
      label: 'INCLUIDO',
      emoji: '🧩',
      title: 'Proyectos creativos de robótica',
      description:
        'Ideas listas para que tu hijo aprenda jugando y creando con sus manos.',
    },
    {
      label: 'INCLUIDO',
      emoji: '⬇️',
      title: 'Recursos descargables',
      description: 'Materiales listos para usar desde casa, sin buscar ni improvisar nada.',
    },
  ],
  bonusTitle: '+14 BONOS',
  bonusHeadline: '🎁 Y ESTO NO ES TODO...',
  bonusSubtitle: 'También te llevás 14 bonos exclusivos',
  bonusDescription: 'Más actividades para seguir creando, jugando y aprendiendo.',
}

export const OFFER = {
  badge: '🔥 OFERTA SOLAMENTE POR HOY',
  title: 'Oferta de hoy',
  description:
    'Solo por hoy te llevás el acceso completo a Mini Constructores + 14 bonos incluidos.',
  productTitle: 'MINI CONSTRUCTORES: ROBÓTICA PARA NIÑOS + 14 BONOS INCLUIDOS',
  subtitle: 'Todo esto te llevás hoy',
  features: [
    '✓ 🤖 Mini Constructores completo',
    '✓ 🧩 +150 proyectos para crear',
    '✓ 🎥 Videos paso a paso',
    '✓ 🖨️ Plantillas imprimibles',
    '✓ 🎁 14 BONOS INCLUIDOS',
    'Sin costo extra hoy',
    '✓ ⚡ Acceso inmediato',
    '✓ ♾️ Acceso de por vida',
    '✓ 🏠 Materiales de casa',
  ],
  disclaimer: 'Recibís el acceso en tu email después de la compra.',
  secure: '🔒 Compra 100% segura y protegida por Mercado Pago.',
  warning: '⚠️ Precio promocional disponible solamente por hoy',
}

export const TESTIMONIALS = [
  { quote: 'Dejó de pedirme el celular.', name: 'Valeria', role: 'mamá de Tomi' },
  { quote: 'No tuve que pensar nada.', name: 'Camila', role: 'mamá de Benja' },
  { quote: 'Creó todo con lo que había en casa.', name: 'Rocío', role: 'mamá de Thiago' },
  { quote: 'Estaba re orgullosa de lo que hizo.', name: 'Daniela', role: 'mamá de Sofi' },
]

export const FAQS = [
  {
    question: '¿Cómo recibo el acceso?',
    answer: 'Lo recibís por email después de la compra.',
  },
  {
    question: '¿Es físico o digital?',
    answer: 'Es 100% digital. No se envía nada físico.',
  },
  {
    question: '¿Desde dónde puedo verlo?',
    answer: 'Desde celular, tablet o computadora.',
  },
  {
    question: '¿Incluye videos?',
    answer: 'Sí, incluye algunos proyectos en video para seguir paso a paso.',
  },
  {
    question: '¿Tengo que saber robótica?',
    answer: 'No. Está pensado para hacerlo fácil desde casa.',
  },
  {
    question: '¿Necesito materiales caros?',
    answer:
      'No. Usan cartón, tapitas, cajas, botellas, papel y cosas simples.',
  },
  {
    question: '¿Para qué edad sirve?',
    answer:
      'Para niños que disfrutan crear, armar, pintar y experimentar. Los más chicos pueden hacerlo con ayuda.',
  },
  {
    question: '¿Cuánto dura el acceso?',
    answer: 'El acceso es de por vida. Podés entrar cuando quieras.',
  },
  {
    question: '¿Vienen los 14 bonos?',
    answer: 'Sí. Los 14 bonos vienen incluidos hoy sin costo extra.',
  },
  {
    question: '¿Puedo pagar en cuotas?',
    answer: 'Sí. Podés pagar en 3 cuotas sin interés.',
  },
]
